import { LowerCasePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { ctaLayout1Style } from '@components/cta/components/cta-layout-1/config';
import { CtaLayout1, CtaLayout1Style } from '@components/cta/components/cta-layout-1/model';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { ColorPipe } from '@shared/pipes';

@Component({
  selector: 'app-cta-layout-1',
  imports: [TitleComponent, ButtonComponent, ColorPipe, LowerCasePipe, NgClass],
  templateUrl: './cta-layout-1.component.html',
  styleUrl: './cta-layout-1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaLayout1Component implements OnInit {
  data = input.required<CtaLayout1>();

  title = signal<Title>(null!);
  style = signal<CtaLayout1Style>(null!);

  ngOnInit(): void {
    this.style.set(ctaLayout1Style[this.data().theme]!);
    if (this.data().title) {
      this.title.set({
        level: 'SPAN',
        size: {
          mobile: 'H2',
          desktop: 'H3',
        },
        text: this.data().title || '',
        color: this.style().textColor,
        align: {
          mobile: 'CENTER',
          desktop: 'CENTER',
        },
      });
    }
  }
}
